/**
 * Danish phone helpers: normalize to "xxxx xxxx".
 * "Tlf." prefix is only for profile dropdown via formatPhoneLabel().
 */

export function phoneDigits(value) {
  let digits = String(value || '').replace(/\D/g, '')
  if (digits.startsWith('0045') && digits.length >= 12) {
    digits = digits.slice(4)
  } else if (digits.startsWith('45') && digits.length >= 10) {
    digits = digits.slice(2)
  }
  return digits
}

/** Store/display form: "xxxx xxxx" for 8-digit DK numbers, else trimmed original digits spaced lightly. */
export function normalizePhone(value) {
  const raw = String(value || '').trim()
  if (!raw) return ''
  const digits = phoneDigits(raw)
  if (digits.length === 8) {
    return digits.slice(0, 4) + ' ' + digits.slice(4)
  }
  if (digits.length === 0) return ''
  return digits
}

export function formatPhoneLabel(value) {
  const normalized = normalizePhone(value)
  if (!normalized) return ''
  return 'Tlf. ' + normalized
}

export function phoneTelHref(value) {
  const digits = phoneDigits(value)
  return digits ? 'tel:+45' + digits : ''
}
